import React, { ReactElement, useContext } from "react";
import { Col, Row } from "react-bootstrap";
import CalculatorContext, { Question } from "./CalculatorContext";
import "./css/style.css";

export default function CalculatorYesNo({ data }: { data: Question }): ReactElement {
  const { setSelected, setAnswer, questions, translation } = useContext(CalculatorContext);

  const handleAnswer = (answer: string) => {
    setAnswer(data.id, answer);
    setSelected(questions.find((question) => question.id === data.id + 1) || questions[0]);
  };
  return (
    <>
      <Row
        className="bg-white project-tile-box-shadow-divelit-grey-10 project-tile project-tile-border ms-0 me-0 ms-md-5 me-md-5 mt-5 p-3 p-xl-5 p-lg-4 result-card"
        style={{ borderTop: "12px solid var(--divelit-plum)" }}
      >
        <Col xs={12} sm={12} lg={12} xxl={12} className="order-2 order-lg-1 p-0">
          <div className="question-card">
            <Row className="d-flex flex-row align-items-center">
              <div className="ms-0 d-flex flex-column flex-md-row gap-3">
                <h4 className="mb-0 w-fit-content font-divelit-plum ">{data.id}</h4>
                <h5 style={{ textAlign: "left"}}>{data.question}</h5>
              </div>
            </Row>
            <Row>
              <Col xs={12} sm={12} className="mt-3 mt-lg-4">
                <div className="d-flex flex-row gap-2 calculator-align-center">
                  <a
                    className="bg-divelit-plum-50 paragraph-small button-wo-border reverse-button calculator-option-button"
                    onClick={() => handleAnswer("no")}
                  >
                    {translation.card.button.no}
                  </a>
                  <a
                    className="button-wo-border bg-divelit-plum-70 paragraph-small calculator-option-button"
                    onClick={() => handleAnswer("yes")}
                  >
                    {translation.card.button.yes}
                  </a>
                </div>
              </Col>
            </Row>
          </div>
          <Row className="mt-3 mt-lg-4 mt-xl-4 mt-xxl-4 calculator-align-end">
            <p
              className="paragraph-medium w-fit-content mt-2 mt-md-auto mb-auto ms-5 ms-md-3 ps-0 ps-md-0 text-end font-divelit-grey-50"
              style={{ textAlign: "left" }}
            >
              {data.source}
            </p>
          </Row>
        </Col>
      </Row>
    </>
  );
}
